import { extensionsConfig } from "@/config/extensionsConfig";
import translatedRoutesSlugs from "translatedRouteSlugs";

export const getSupportedExtensions = (path: string): string[] => {
    const key = getUploaderPathKey(path) || "";
    return (extensionsConfig as any)[key] || extensionsConfig["bulk-resize"];
};

export const getUploaderPathKey = (path: string, fallback: string = "resizer"): string | undefined => {
    path = decodeURIComponent(path);
    const uploaderPathname = path.split("/").at(1);
    const key =
        Object.entries(translatedRoutesSlugs)
            .find(([_, value]) => {
                return Object.values(value).find((value) => value === uploaderPathname);
            })?.[0]
            .split("/")[1] || fallback;
    return key;
};
